class Errors {

    constructor() {
        this.errors = {};
    }

    has(field) {
        if (!this.errors) {
            return false;
        }
    
        return this.errors.hasOwnProperty(field);
    }

    any() {
        return Object.keys(this.errors).length > 0;
    }

    get(field) {
        if (this.errors && this.errors[field]) {
            return this.errors[field][0];
        }
    }

    getAll(field) {
        if (this.errors[field]) {
            return this.errors[field];
        }
    }

    all() {
        return this.errors;
    }

    add(errors) {
        this.errors = errors;
    }

    clear(field) {
        if (field) {
            Vue.delete(this.errors, field);
            
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }
}

export default Errors;



// WEBPACK FOOTER //
// ./resources/assets/js/core/errors.js